import { axiosInstance } from 'api/instance';
import { LeadershipResponse } from 'api/Leadership/types';
import urls from 'api/Leadership/urls';

import { AxiosResponse } from 'axios';

export const getLeadershipRequest = ({ signal }: AbortController): Promise<AxiosResponse<LeadershipResponse>> => {
  return axiosInstance.get<LeadershipResponse>(urls.leadershipUrl, { signal });
};
